import { useQuery } from '@tanstack/react-query';
import { getAyahsBySurah, getAyah } from '@/lib/queries/ayahs';
import type { Ayah } from '@/types/domain';

export function useAyahsBySurah(surahId: number | null) {
  return useQuery<Ayah[], Error>({
    queryKey: ['ayahs', 'by-surah', surahId],
    // Safe to assert non-null: `enabled` gates the call.
    queryFn: () => getAyahsBySurah(surahId as number),
    enabled: surahId !== null && surahId > 0,
  });
}

export function useAyah(surahId: number | null, ayahNumber: number | null) {
  return useQuery<Ayah | null, Error>({
    queryKey: ['ayahs', surahId, ayahNumber],
    queryFn: () => getAyah(surahId as number, ayahNumber as number),
    enabled:
      surahId !== null && surahId > 0 && ayahNumber !== null && ayahNumber > 0,
  });
}
